/**
 * Whether the session is over, as the app sees it (ADR-005). A tab in the background does not
 * ask for the time left - so its own clock can run out while another tab kept the session open.
 * Before it takes the app off the screen on its clock alone, it asks once more: over is what the
 * API says (`lost`), or a clock that ran out on the latest answer there is (`checked` is the
 * answer the tab asked about once its clock ran out - when no newer one came, that is the last).
 */
export function sessionEnded({ lost, left, received, checked, }) {
    if (lost)
        return true;
    return left !== null && left <= 0 && checked === received;
}
//# sourceMappingURL=session-end.js.map